/**
 * Research 횟수의 **고객이 읽는 글** — 막힘 안내 · 허브 띠의 귀띔.
 *
 * 🔑 한도 숫자는 플랜 표에서 읽은 값을 받는다 — 글에 30 을 박지 않는다.
 */

import { IWorkspacePlan } from 'src/constants/plan-service';

/** 업그레이드 안내가 찾는 필드 이름 — 플랜 표의 `research.researchMonthlySearches` */
export const RESEARCH_QUOTA_FIELD = 'researchMonthlySearches';

/** 이번 달 횟수를 다 썼을 때 — 업그레이드 안내의 본문 */
export function researchMonthlyLimitCopy(limit: number): string {
  return `이번 달 Research ${limit}회를 모두 사용했습니다 · ${IWorkspacePlan.planNameKor.plan_individual} 플랜부터 무제한으로 사용할 수 있습니다`;
}

/** 허브 전환 띠 단추 옆 귀띔 — 한도가 있는 플랜만 */
export const RESEARCH_ONE_USE_HINT = 'Research 1회 사용';

/** 홈 답 카드 칩 줄 귀띔 — 답 카드는 세지 않는다 · 「전체 보기」로 그 화면에 들어가 검색이 나갈 때 센다(이번 달 처음 쓰는 말만) */
export const RESEARCH_ON_OPEN_HINT = '전체 보기 때 Research 1회';
